import { nanoid } from 'nanoid'
import React, { Component } from 'react'
import ButtonAnimated from '../components/buttons/ButtonAnimated'
import TextInput from '../components/inputs/TextInput'
import inputComponents from '../components/tableComponents'
import WidgetComponents from '../components/widgets/WidgetComponents'
import HttpServices from '../utils/Http.services'
import { translate } from '../utils/useful'
import { formBuilderGroups, FormBuilderObjects } from '../variables/formBuilderData'
import { widgetsGroups, widgetsList } from '../variables/widgetsList'
import CollectionStage from './Applets/database/stage/CollectionStage'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import CAAccess from './CreateApplet/CAAccess'
import StagesManager from '../components/StagesManager'

class ProjectBuilder extends Component {

    state = {
        name: '',
        data: {
            collectionInfo: { automations: [{ id: nanoid(), name: 'first' }, { id: nanoid(), name: 'second' }], type: 'multi' }
        },
        type: 'dashboard',
        componentsInfo: {
            form: { object: FormBuilderObjects, groups: formBuilderGroups, components: inputComponents },
            dashboard: { object: widgetsList, groups: widgetsGroups, components: WidgetComponents },
        },
        name: null,
        isLoadingData: false,
        defaultStage: [{ id: `${nanoid()}` }],
    }

    componentDidMount() {
        // this.props.setHeader({
        //     'toolbar': null,
        //     'showToolbar': false,
        //     topHeaderComponent: this.topHeaderComponent,
        //     headerIdentityComponent: this.headerIdentityComponent,
        //     backAction: () => this.props.changePage()
        //     // backAction: () => this.props.changePage('dashboard')
        // })
    }

    saveProject = (permissionsData) => {

        let page = this.props.page
        console.log('saveProjects', this.state.name)
        this.setState({ isLoadingData: true })
        console.log('nameeeeeeeee', this.state.name, !this.state.name?.trim())
        if (this.state.name?.trim() == null || !this.state.name?.trim()) {
            this.setState({ name: null }, () => {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.NameRequired', description: '{{lang}}errors.NameRequired' })
                this.setState({ isLoadingData: false })
            })
        }
        if (Object.values(this.state.data).length == 0) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty', description: '{{lang}}errors.ContentEmpty' })
            this.setState({ isLoadingData: false })
        }
        if (this.state.name && this.state.name.trim() != null && this.state.data) {
            let data = this.state.data ?? {}
            // for (const [key, value] of Object.entries(permissionsData)) {
            //     data[key] = value
            // }

            if (page.postBody) {
                data = { ...data, ...page.postBody }
            }
            console.log('dataisdas', data)
            console.log('variiia', this.props.variables)
            for (const [key, value] of Object.entries(data)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
            data.permissions = permissionsData
            data.name = this.state.name
            data.type = 'collection'
            if (this.props.windowData?.info?.type) {
                data.type = this.props.windowData?.info?.type
            }
            if (this.props.windowData?.info?.mode) {
                data.mode = this.props.windowData?.info?.mode
            }
            if (this.props.windowData?.info?.frame) {
                data.frame = this.props.windowData?.info?.frame
            }
            data.applet = this.props.variables.appletId
            // this.changeValue('name', this.state.name)
            console.log('this.propsfewf', this.props.windowData.info)
            HttpServices.request(page.addUrl, data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                let path = this.props.windowData.path
                let newPath = [path[0], path[1], path[2]]
                console.log('newPathss', newPath)
                // this.props.changeWindowLink(newPath)
                // this.props.updateModules(fetchResult.info, true)
                this.props.changeWindow(newPath)
                this.setState({ isLoadingData: false })
            })
        }
    }

    // topHeaderComponent = () => {
    //     return (
    //         <div className='flexc'>
    //             <ButtonAnimated
    //                 iconwidth='24px'
    //                 onClick={() => this.saveProject()}
    //                 title='Save'
    //                 icon='/assets/icons/plus-white.svg'
    //                 textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
    //                 invert={!this.props.colors?.iconInvert}
    //                 bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
    //                 isLoading={this.state.isLoadingData}
    //             />
    //         </div>
    //     )
    // }

    headerIdentityComponent = () => {
        return (
            <div className='' >
                {/* <TextInput data={this.state?.name} changeValue={this.changeValue} header={{ key: 'name', information: { rows: 1, placeholder: translate('View Name') }, }} /> */}
                <input onChange={(e) => this.setName(e.target.value)} required={true} value={this.state.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert view name ...')} />
            </div>
        )
    }

    setName = (value) => {
        console.log('nameeeeeeeee323', value)
        this.setState({ name: value }, () => {
            console.log('this.state.nameUpdated', this.state.name)
        })
    }

    changeValue = (key, value, extra) => {
        this.setState({ [key]: value })
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'CollectionBuilder') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    nextStage = (rawData) => {
        let data = this.props.data
        if (!data.collectionInfo) {
            data.collectionInfo = {}
        }
        data.collectionInfo.automations = this.state.defaultStage
        this.props.setData('data', data, 'CollectionBuilder', () => {
            this.props.changeStage('collectionPermissions')
        })
    }

    render() {
        return (
            // <div>
            // {console.log('projectbuilder', this.state.data)}
            <div className='h-100 w-100'>
                {/* <TextInput data={this.state?.name} changeValue={this.changeValue} header={{ key: 'name', information: { rows: 1, placeholder: translate('View Name') }, }} /> */}
                <StagesManager height={'100%'} ref={el => this.stageManager = el} >

                    <CollectionStage headerIdentityComponent={this.headerIdentityComponent} baseUrl={this.props.baseUrl} stageName={'collectionstage'} language={this.props.language} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} initData={this.state.data} page={this.props.page} submitCollection={this.submitCollection} data={this.state.data} setData={this.setData} changeStage={this.props.changeStage} lastStagePage={this.props.lastStagePage} saveTitle='submit' applet={this.props.applet} pages={this.props?.pages} width={100} height={this.props.height} type={'collectionstage'} stage={0} user={this.props.user} modules={this.props.modules} changePage={this.props.changePage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={this.props.variables} functionsHandler={this.functionsHandler} />
                    <CAAccess hideHeader={true} handleNextStage={this.saveProject} baseUrl={this.props.baseUrl} type={'collectionPermissions'} initData={this.state.data} language={this.props.language} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} page={this.props.page} submitCollection={this.submitCollection} data={this.state.data} setData={this.onSavePermissions} lastStagePage={this.props.lastStagePage} applet={this.props.applet} pages={this.props?.pages} width={100} height={this.props.height} stage={1} user={this.props.user} modules={this.props.modules} stageName={'collectionPermissions'} changePage={this.changeStage} title={"save"} description={"Add Permissions"} route={this.props.route} variables={this.props.variables} functionsHandler={this.functionsHandler} />
                </StagesManager>
            </div>
            // </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectBuilder);